import { Quote } from "lucide-react"

import { lazyPage } from "../lazy-page"
import { defineDashboardModule } from "../types"

export const testimonials = defineDashboardModule({
  id: "testimonials",
  nav: [
    {
      group: "Publishing",
      title: "Testimonials",
      to: "/testimonials",
      icon: Quote,
    },
  ],
  routes: [
    {
      path: "/testimonials",
      component: lazyPage(
        () => import("./routes/testimonials-page"),
        "TestimonialsPage"
      ),
    },
  ],
})
